"use strict";

function ChangeCurrency(
    subCallback_I
)
{
    if (typeof window !== 'undefined') {
        var $ = window.$;
        this.currencySelector = $('#currency-selector');
        this.subSetChangeListener();
        this.callerCallback = subCallback_I;
    }
}

ChangeCurrency.prototype.subSetChangeListener = function(){
    var context = this;
    this.currencySelector.on('change', function(){
        context.subCurrencyChanged();
    });
}

ChangeCurrency.prototype.subCurrencyChanged = function()
{
    var selectedCurrency = this.currencySelector.children("option:selected").val();
    switch (selectedCurrency) {
        case "MXN":
            $("#flag-image-mxn").show();
            $("#flag-image-usa").hide();
            break;
        case "USD":
            $("#flag-image-mxn").hide();
            $("#flag-image-usa").show();
            break;
        default:
            break;
    }

    if (this.callerCallback != null)
    {
        this.callerCallback(selectedCurrency);
    }
}

ChangeCurrency.prototype.subHide = function()
{
    this.currencySelector.parent().hide();
}

ChangeCurrency.prototype.subShow = function()
{
    this.currencySelector.parent().show();
}

ChangeCurrency.prototype.strGetSelectedCurrency = function()
{
    return this.currencySelector.children("option:selected").val();
}

module.exports = ChangeCurrency;